import { defineMessages } from 'react-intl';

export const chatInputMessages = defineMessages({
  stopGenerating: {
    defaultMessage: 'Stop generating', id: 'RKGAOzwaAk',
    description: 'Aria label for submit button while a response is streaming',
  },
  submitMessage: {
    defaultMessage: 'Submit message', id: '6FQaghIY6P',
    description: 'Aria label for send button in the chat composer',
  },
  uploadErrorsBlockSend: {
    defaultMessage:
      'Some attachments failed to upload. Retry or remove them to send.', id: 'OVmKWKWAZN',
    description: 'Tooltip when upload errors prevent sending a message',
  },
  protocolsDisabledTooltip: {
    defaultMessage: 'Add a session or patient to run protocols', id: '6F76Fk9JWL',
    description: 'Tooltip when protocols slash menu is disabled without context',
  },
  defaultPlaceholder: {
    defaultMessage: 'Ask Heidi anything...', id: 'Nyy1LiEFw1',
    description: 'Default placeholder in the chat composer input',
  },
  dropFilesHere: {
    defaultMessage: 'Drop files here', id: 'Hjl35vIH6T',
    description: 'Overlay label when dragging files over the chat composer',
  },
  fileTooLarge: {
    defaultMessage: 'File too large', id: 'aq/dw8Mdmr',
    description: 'Toast title when a single attachment exceeds the size limit',
  },
  fileTooLargeDescription: {
    defaultMessage:
      '“{fileName}” exceeds the {maxSizeMB}MB limit. Try a smaller file.', id: '2M+/rGvPBX',
    description: 'Toast body when one file exceeds the attachment size limit',
  },
  filesTooLargeMultiple: {
    defaultMessage:
      '{count, plural, one {# file exceeds the {maxSizeMB}MB limit. Try a smaller file.} other {# files exceed the {maxSizeMB}MB limit. Try smaller files.}}', id: '4K/mRjULSe',
    description: 'Toast body when multiple files exceed the attachment size limit',
  },
  uploadFailed: {
    defaultMessage: 'Upload failed', id: 'bQ/TBx2sGy',
    description: 'Toast title when an attachment upload fails',
  },
  uploadFailedDescription: {
    defaultMessage:
      '“{fileName}” couldn’t be uploaded. Please try again.',
    id: 'zfNYDHu8J3',
    description:
      'Toast body when a single file upload fails. Intentionally does not leak the raw backend error — the file card surfaces the per-file reason.',
  },
  uploadFailedMultiple: {
    defaultMessage:
      '{count, plural, one {# file failed to upload. Retry or remove it.} other {# files failed to upload. Retry or remove them.}}', id: 'Kg/R014+Kh',
    description: 'Toast body when multiple file uploads fail',
  },
  uploadRateLimited: {
    defaultMessage: 'Too many uploads',
    id: 'IhzxM94FqA',
    description: 'Toast title when attachment uploads are rate limited',
  },
  uploadRateLimitedDescription: {
    defaultMessage: 'Wait a minute, then retry the failed files.',
    id: 'Ap5mN6dRlQ',
    description: 'Toast body when attachment uploads are rate limited',
  },
  fileCardFailed: {
    defaultMessage: 'Failed', id: '4OnIL98QJ7',
    description: 'Short error label on a failed attachment file card',
  },
  fileCardTooLarge: {
    defaultMessage: 'Too large', id: 'gC3WF1wqZT',
    description: 'Short error label on an attachment that exceeded the size limit',
  },
  fileCardUnsupported: {
    defaultMessage: 'Not supported', id: '6Uc/1KiZDD',
    description: 'Short error label on an attachment whose file type isn’t allowed',
  },
  attachmentsAllowedFormatsLabel: {
    defaultMessage:
      'documents, spreadsheets, images, or plain text',
    id: 'myQiIvzRYl',
    description:
      'Bucketed list of file kinds accepted as chat attachments, embedded in rejection toasts',
  },
  audioAttachmentTitle: {
    defaultMessage: 'Media files can’t be attached here',
    id: 'J94IshN8Yk',
    description:
      'Toast title when an audio or video file (anything in AUDIO_FILE_EXTENSIONS, which includes .mp4) is dropped onto the chat input',
  },
  audioAttachmentDescription: {
    defaultMessage:
      'To transcribe audio or video, start a new session and add it from there.',
    id: 'v9AOo68+JV',
    description:
      'Toast body when an audio or video file is dropped onto the chat input',
  },
  linkedSessionSubtitleWithPatientAndDate: {
    defaultMessage: '{patientName} · {sessionDate}', id: 'ZCOy6QcFJH',
    description:
      'Linked session badge subtitle showing patient name and session date',
  },
});
